import { useEffect, useState } from "react";
import { Cloud, CloudOff, RefreshCw, Check } from "lucide-react";
import { subscribeSync, forceResync } from "../lib/sync";
import { useLanguage } from "../i18n/LanguageContext";

// Small connection status pill, bottom-left. Exposes a "resync" action on click.
export default function SyncIndicator() {
  const { t } = useLanguage();
  const [status, setStatus] = useState({ online: null, syncing: false, error: null, lastSync: null });
  const [justSynced, setJustSynced] = useState(false);

  useEffect(() => {
    return subscribeSync((s) => setStatus(s));
  }, []);

  const handleResync = async () => {
    setJustSynced(false);
    const result = await forceResync();
    if (!result.ok) return;
    setJustSynced(true);
    setTimeout(() => setJustSynced(false), 1800);
  };

  // Hide until we have any status.
  if (status.online === null && !status.syncing) return null;

  const online = !!status.online;
  const syncing = !!status.syncing;

  let StatusIcon = CloudOff;
  if (syncing) StatusIcon = RefreshCw;
  else if (justSynced) StatusIcon = Check;
  else if (online) StatusIcon = Cloud;

  let label = t("offline");
  if (syncing) label = t("syncing");
  else if (online) label = t("synced");

  return (
    <div
      className="fixed bottom-3 left-3 z-[5] select-none"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <button
        onClick={handleResync}
        title={status.error || (online ? t("connected") : t("retry"))}
        className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border text-[11px] tracking-[0.14em] uppercase transition-colors backdrop-blur ${
          online
            ? "bg-white/80 border-[#E6E0D4] text-[#2B7A6B] hover:bg-white"
            : "bg-white/80 border-red-200 text-red-600 hover:bg-white"
        }`}
      >
        <StatusIcon size={12} className={syncing ? "animate-spin" : undefined} />
        <span>{label}</span>
      </button>
    </div>
  );
}
